/**
 * AbstractPopupMediator.js
 * Created on 12-okt-2015
 *
 *
 * @author Reinier Feijen for Ranj
 **/

import Anchor from "../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import FillArea from "../../../../lib/html5-software-library/src/ranj/layout/FillArea";
import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import AbstractMediator from "./AbstractMediator";

export default class AbstractScreenMediator extends AbstractMediator {
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);
    }

    initialize() {
        super.initialize();
        //No stretching necessary if bg in assets already covers min and max ratios!
        // if (this._target.bg) {
        //     this.stretchBackground(this._target.bg);
        // }
    }

    stretchBackground(bg, bounds) {
        const b = bounds || bg.nominalBounds;
        this.anchorObject(bg, Anchor.C, new FillArea(b, FillArea.PROPORTIONAL_OUTSIDE));
        if (getURLParameter("debuglines") == "1") {
            bg.addChild(new createjs.Shape()).graphics
                .s("#808").ss(6)
                .mt(b.x, b.y)
                .lt(b.x + b.width, b.y + b.height)
                .mt(b.x, b.y + b.height)
                .lt(b.x + b.width, b.y)
                .r(b.x, b.y, b.width, b.height);
        }
    }

}